import React from "react";

import { EMPTY_STRING } from "../../../constants";
import { PRODUCT_TYPES_ENUMS } from "../../../system/globalEnums";
import SelectDropdownFormik from "../selectDropdown/SelectDropdownFormik";
import InputTextField from "../inputTextField/InputTextField";
import { isTcgPlayerApi } from "../../utility";

const Set = (props) => {
  const {
    isFormik = true,
    value,
    setFieldValue,
    label = EMPTY_STRING,
    priceChartingProductInfo: { productMetaData },
    priceChartingProductInfo,
  } = props;

  return (
    isTcgPlayerApi(productMetaData) &&
    (isFormik ? (
      <>
        {label && <label className="field-label">{label}</label>}
        {/* <SelectDropdownFormik
          name="set"
          value={value}
          setFieldValue={setFieldValue}
          options={productMetaData?.setList ?? []}
        /> */}
        <InputTextField
          name="set"
          title="Set"
          maxLength={100}
          disabled={true}
          placeHolder="Enter Set"
          className="border"
          containerDivClassName="modal-input-field-min-width"
        />
      </>
    ) : null)
  );
};

export default Set;
